
export default {
  name: 'SvgContainer',
};
